var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "银行名称", prop: "card_type" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "请选择银行名称",
                filterable: "",
                loading: _vm.bankLoading,
              },
              on: { change: _vm.handleBankNameChange },
              model: {
                value: _vm.form.card_type,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "card_type", $$v)
                },
                expression: "form.card_type",
              },
            },
            _vm._l(_vm.bankOptions, function (opt) {
              return _c("el-option", {
                key: opt.label,
                attrs: { label: opt.label, value: opt.label },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "卡号", prop: "card_no" } },
        [
          _c("el-input", {
            attrs: {
              placeholder: "请输入卡号",
              clearable: "",
              maxlength: "64",
              "show-word-limit": "",
            },
            model: {
              value: _vm.form.card_no,
              callback: function ($$v) {
                _vm.$set(
                  _vm.form,
                  "card_no",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "form.card_no",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }